<script>
import { mapGetters } from "vuex";
import {
  MDBContainer, 
  MDBRow, 
  MDBCol, 
  MDBTabs,
  MDBTabNav,
  MDBTabContent,
  MDBTabItem,
  MDBTabPane
} from "mdb-vue-ui-kit";
import HeaderFragment from './HeaderFragment.vue'
import WelcomePanel from './WelcomePanel.vue'
import QuotePanel from './QuotePanel.vue'
import NextPanel from './NextPanel.vue'
import { scroller } from "vue-scrollto/src/scrollTo";
import clientConfig from '/src/config/client';

export default {
  name: 'CalculatorScaffold',
  components: {
    MDBContainer,
    MDBRow,
    MDBCol,
    MDBTabs,
    MDBTabNav,
    MDBTabContent,
    MDBTabItem,
    MDBTabPane,

    HeaderFragment,
    WelcomePanel,
    QuotePanel,
    NextPanel
  },

  setup() {},

  mounted() {
    document.querySelector("#mainNav")
      .addEventListener('keydown', this.handleAccessibleTabs, true);
  },

  beforeUnmount() {
    document.querySelector("#mainNav")
      .removeEventListener('keydown', this.handleAccessibleTabs);
  },

  methods: {
    triggerHeightCheck() {
      // Add slight delay otherwise incorrect height is read
      var rf = this;
      setTimeout(function() {
        rf.$refreshIframeHeight();
      }, 300);
    },

    clickToTab(tabNum) {
      const scrollTo = scroller();
      this.$store.commit("setActiveTab", tabNum);
      scrollTo("#iqApp");
      this.triggerHeightCheck();
      this.$gtag.event('click', {
        'event_category': 'navigation',
        'event_label': 'navigateTo' + tabNum,
        'value': 1
      });
      if (this.debugMode)
        console.log("GTAG Event: navigateTo" + tabNum);
    },

    handleAccessibleTabs(event) {
      if (event.keyCode === 37 || event.keyCode === 39) { // Left or Right
        const currentTabPos = parseInt(event.srcElement.id.substring(event.srcElement.id.length - 1));
        if (event.keyCode === 37) { // Left
          if (currentTabPos <= 1) {
            document.querySelector("#tab-tab3").focus();
          } else {
            document.querySelector("#tab-tab" + (currentTabPos - 1)).focus();
          }
        } else if (event.keyCode === 39) { // Right
          if (currentTabPos >= 3) {
            document.querySelector("#tab-tab1").focus();
          } else {
            document.querySelector("#tab-tab" + (currentTabPos + 1)).focus();
          }
        }
      } else if (event.keyCode === 13 || event.keyCode === 32) {
        document.querySelector("#" + event.srcElement.id).click();
      }
    }
  },

  computed: {
    ...mapGetters([
      "debugMode",
      "activeTab"
    ])
  },

  data() {
    return {
      clientConfig,
      tabNames: [
        clientConfig.content.general.tabLabels.welcomeTab,
        clientConfig.content.general.tabLabels.calculationTab,
        clientConfig.content.general.tabLabels.whatsNextTab
      ]
    }
  }
}
</script>

<template>
  <MDBContainer>
    <MDBRow class="p-0">
      <MDBCol 
        col="12"
        sm="11"
        class="p-0 mx-auto"
      >
        <MDBContainer fluid>
          <MDBRow class="p-0">
            <MDBCol 
              col="12"
              class="clientLogoHolder text-center"
            >
              <a 
                :href="clientConfig.content.general.websiteUrl" 
                class="clientLogo mt-4 mt-sm-0 mb-3 mb-sm-0"
                aria-label="Client Logo"
              ></a>
            </MDBCol>
          </MDBRow>

          <MDBRow class="p-0">
            <MDBCol 
              col="12"
              class="p-0"
            >
              <MDBTabs :modelValue="'tab' + activeTab">
                <MDBTabNav 
                  pills 
                  tabsClasses="calc-nav" 
                  role="tablist" 
                  aria-label="Navigation Tabs" 
                  id="mainNav"
                >
                  <MDBTabItem 
                    tabId="tab1" 
                    :tabindex="activeTab === 1 ? 0 : -1"
                    role="tab" 
                    aria-controls="tab1" 
                    :aria-label="tabNames[0]"
                    :aria-selected="activeTab === 1 ? 'true' : 'false'"
                    @click="clickToTab(1)"
                  >
                    {{ tabNames[0] }}
                  </MDBTabItem>

                  <MDBTabItem 
                    tabId="tab2" 
                    :tabindex="activeTab === 2 ? 0 : -1" 
                    role="tab" 
                    aria-controls="tab2"
                    :aria-label="tabNames[1]"
                    :aria-selected="activeTab === 2 ? 'true' : 'false'"
                    @click="clickToTab(2)"
                  >
                    {{ tabNames[1] }}
                  </MDBTabItem>

                  <MDBTabItem 
                    tabId="tab3" 
                    :tabindex="activeTab === 3 ? 0 : -1" 
                    role="tab" 
                    aria-controls="tab3"
                    :aria-label="tabNames[2]"
                    :aria-selected="activeTab === 3 ? 'true' : 'false'"
                    @click="clickToTab(3)"
                  >
                    {{ tabNames[2]}}
                  </MDBTabItem>
                </MDBTabNav>

                <MDBTabContent>
                  <MDBTabPane tabId="tab1" tabindex="0">
                    <HeaderFragment />
                    <div class="p-0 frame-border">
                      <WelcomePanel />
                    </div>
                  </MDBTabPane>

                  <MDBTabPane tabId="tab2" tabindex="0">
                    <HeaderFragment />
                    <div class="p-0 frame-border">
                      <QuotePanel />
                    </div>
                  </MDBTabPane>

                  <MDBTabPane tabId="tab3" tabindex="0">
                    <HeaderFragment />
                    <div class="p-0 frame-border">
                      <NextPanel />
                    </div>
                  </MDBTabPane>
                </MDBTabContent>
              </MDBTabs>
            </MDBCol>
          </MDBRow>

        </MDBContainer>

      </MDBCol>
    </MDBRow>
    <br />

    <div class="disclaimer" v-html="clientConfig.content.general.disclaimer"></div>

  </MDBContainer>
</template>